function toggleProfileDropdownVisibility() {
  const profileDropdownMenu = document.querySelector(".profile-dropdown-menu");
  if (profileDropdownMenu) {
    profileDropdownMenu.classList.toggle("tw-flex");
  }
}

function handleMPAuthLogin() {
  const { hostname, pathname, search } = window.location;
  const localLoginUrl = "http://127.0.0.1:8000/login/ministrypass";
  const remoteLoginUrl = "https://account.ministrypass.com/login/ministrypass";

  window.location.href =
    (hostname === "127.0.0.1" ? localLoginUrl : remoteLoginUrl) +
    "?redirect=" +
    pathname +
    search;
}

document.addEventListener("DOMContentLoaded", function () {
  const profileDropdownMenu = document.querySelector(".profile-dropdown-menu");
  const profileDropdownToggle = document.querySelector(
    ".profile-dropdown-toggle"
  );

  if (profileDropdownToggle && profileDropdownMenu) {
    document.addEventListener("click", function (event) {
      if (
        profileDropdownMenu !== event.target &&
        profileDropdownToggle !== event.target &&
        !profileDropdownMenu.contains(event.target) &&
        !profileDropdownToggle.contains(event.target)
      ) {
        profileDropdownMenu.classList.remove("tw-flex");
      }
    });
  }
});
